// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as React$1 from "swiper/react";
import * as JsxRuntime from "react/jsx-runtime";
import * as ContentCard$PrezzeeRibbon from "@prezzee/ribbon/src/components/common/ContentCard/ContentCard.bs.js";
import * as Theme__Color$PrezzeeRibbon from "@prezzee/ribbon/src/theme/Theme__Color.bs.js";
import * as DeviceSizeImage$PrezzeeRibbon from "@prezzee/ribbon/src/components/common/DeviceSizeImage/DeviceSizeImage.bs.js";
import * as FullWidthCarousel$PrezzeeRibbon from "@prezzee/ribbon/src/components/common/FullWidthCarousel/FullWidthCarousel.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "@prezzee/ribbon/src/theme/Theme__Typography.bs.js";
import * as ContentCard__Title$PrezzeeRibbon from "@prezzee/ribbon/src/components/common/ContentCard/ContentCard__Title.bs.js";
import * as ContentCard__Description$PrezzeeRibbon from "@prezzee/ribbon/src/components/common/ContentCard/ContentCard__Description.bs.js";
import * as FullWidthCarousel__Slide$PrezzeeRibbon from "@prezzee/ribbon/src/components/common/FullWidthCarousel/FullWidthCarousel__Slide.bs.js";
import * as ContentCard__TopContainer$PrezzeeRibbon from "@prezzee/ribbon/src/components/common/ContentCard/ContentCard__TopContainer.bs.js";
import * as ContentCard__BottomContainer$PrezzeeRibbon from "@prezzee/ribbon/src/components/common/ContentCard/ContentCard__BottomContainer.bs.js";
import * as FullWidthCarousel__SlideContent$PrezzeeRibbon from "@prezzee/ribbon/src/components/common/FullWidthCarousel/FullWidthCarousel__SlideContent.bs.js";

var image = Curry._1(BsCss.style, {
      hd: BsCss.display("block"),
      tl: {
        hd: BsCss.width(BsCss.pct(100)),
        tl: {
          hd: BsCss.borderTopLeftRadius(BsCss.px(8)),
          tl: {
            hd: BsCss.borderTopRightRadius(BsCss.px(8)),
            tl: /* [] */0
          }
        }
      }
    });

var description = Curry._1(BsCss.merge, {
      hd: Theme__Typography$PrezzeeRibbon.Styles.style4,
      tl: {
        hd: Curry._1(BsCss.style, {
              hd: BsCss.color(Theme__Color$PrezzeeRibbon.Business.charcoal),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

var slide = Curry._1(BsCss.style, {
      hd: BsCss.important(BsCss.height("auto")),
      tl: {
        hd: BsCss.display("flex"),
        tl: /* [] */0
      }
    });

var slideContent = Curry._1(BsCss.style, {
      hd: BsCss.important(BsCss.padding2(BsCss.px(10), BsCss.px(13))),
      tl: /* [] */0
    });

var $$global = Curry._1(BsCss.merge, {
      hd: Theme__Typography$PrezzeeRibbon.Styles.body,
      tl: {
        hd: Curry._1(BsCss.style, {
              hd: BsCss.width(BsCss.pct(100)),
              tl: {
                hd: BsCss.important(BsCss.marginTop(BsCss.rem(1.5))),
                tl: /* [] */0
              }
            }),
        tl: /* [] */0
      }
    });

var Styles = {
  image: image,
  description: description,
  slide: slide,
  slideContent: slideContent,
  $$global: $$global
};

function BrazeContentCards(props) {
  var match = React.useState(function () {
        
      });
  var setCardData = match[1];
  var cardData = match[0];
  var match$1 = React.useState(function () {
        return 0;
      });
  var setTotalCards = match$1[1];
  var totalCards = match$1[0];
  React.useEffect((function () {
          var timeout = setTimeout((function (param) {
                  var hasLoaded = window.appboy !== undefined;
                  if (hasLoaded) {
                    window.appboy.openSession();
                    window.appboy.requestContentCardsRefresh();
                    return window.appboy.subscribeToContentCardsUpdates(function (updates) {
                                var cards = updates.cards;
                                var totalCards = cards.length;
                                if (totalCards > 0) {
                                  Curry._1(setCardData, (function (param) {
                                          return cards;
                                        }));
                                  return Curry._1(setTotalCards, (function (param) {
                                                return totalCards;
                                              }));
                                }
                                
                              });
                  }
                  
                }), 1000);
          return (function (param) {
                    clearTimeout(timeout);
                  });
        }), []);
  var contentCardComponent = cardData !== undefined ? Belt_Array.mapWithIndex(cardData, (function (idx, card) {
            var key = String(idx);
            var extras = card.extras;
            var title = card.title;
            if (extras == null) {
              return null;
            }
            var card_type = Belt_Option.getWithDefault(extras.card_type, "");
            var $$location = Belt_Option.getWithDefault(extras.location, "");
            if ($$location !== "wall_of_cards_web") {
              return null;
            }
            if (card_type !== "slider") {
              return null;
            }
            var image_desktop = Belt_Option.getWithDefault(extras.image_desktop, "");
            var image_tablet = Belt_Option.getWithDefault(extras.image_tablet, "");
            var image_mobile = Belt_Option.getWithDefault(extras.image_mobile, "");
            var desktopImage = Caml_option.some(JsxRuntime.jsx("img", {
                      className: image,
                      alt: title,
                      src: image_desktop
                    }));
            var tabletImage = Caml_option.some(JsxRuntime.jsx("img", {
                      className: image,
                      alt: title,
                      src: image_tablet
                    }));
            var mobileImage = Caml_option.some(JsxRuntime.jsx("img", {
                      className: image,
                      alt: title,
                      src: image_mobile
                    }));
            var image$1 = JsxRuntime.jsx(DeviceSizeImage$PrezzeeRibbon.make, {
                  desktop: desktopImage,
                  smallScreen: tabletImage,
                  tablet: undefined,
                  mobile: mobileImage
                });
            var slideContent$1 = JsxRuntime.jsx(FullWidthCarousel__Slide$PrezzeeRibbon.make, {
                  children: JsxRuntime.jsx(FullWidthCarousel__SlideContent$PrezzeeRibbon.make, {
                        children: JsxRuntime.jsxs(ContentCard$PrezzeeRibbon.make, {
                              children: [
                                JsxRuntime.jsx(ContentCard__TopContainer$PrezzeeRibbon.make, {
                                      children: image$1
                                    }),
                                JsxRuntime.jsxs(ContentCard__BottomContainer$PrezzeeRibbon.make, {
                                      children: [
                                        JsxRuntime.jsx(ContentCard__Title$PrezzeeRibbon.make, {
                                              children: title
                                            }),
                                        JsxRuntime.jsx(ContentCard__Description$PrezzeeRibbon.make, {
                                              children: card.description
                                            })
                                      ]
                                    })
                              ]
                            }),
                        className: slideContent
                      })
                });
            var href = Belt_Option.getWithDefault(card.url, "");
            var slide$1 = href === "" ? JsxRuntime.jsx(JsxRuntime.Fragment, {
                    children: Caml_option.some(slideContent$1)
                  }) : JsxRuntime.jsx("a", {
                    children: slideContent$1,
                    href: href
                  });
            if (totalCards !== 1) {
              return JsxRuntime.jsx(React$1.SwiperSlide, {
                          className: slide,
                          children: slide$1
                        }, key);
            } else {
              return slide$1;
            }
          })) : null;
  if (totalCards !== 0) {
    return JsxRuntime.jsx(FullWidthCarousel$PrezzeeRibbon.make, {
                children: contentCardComponent,
                autoplay: true,
                className: $$global
              });
  } else {
    return null;
  }
}

var ContentCard;

var TopContainer;

var BottomContainer;

var Title;

var Description;

var DeviceSizeImage;

var Carousel;

var Slide;

var SlideContent;

var make = BrazeContentCards;

export {
  ContentCard ,
  TopContainer ,
  BottomContainer ,
  Title ,
  Description ,
  DeviceSizeImage ,
  Carousel ,
  Slide ,
  SlideContent ,
  Styles ,
  make ,
}
/* image Not a pure module */
